import { render, staticRenderFns } from "./LinkBusiness.vue?vue&type=template&id=116de399&"
import script from "./LinkBusiness.vue?vue&type=script&lang=ts&"
export * from "./LinkBusiness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports